import { render } from "./right.drawer.vue?vue&type=template&id=497f2f30&scoped=true"
import script from "./right.drawer.vue?vue&type=script&lang=js"
export * from "./right.drawer.vue?vue&type=script&lang=js"

import "./right.drawer.vue?vue&type=style&index=0&id=497f2f30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497f2f30"]])

export default __exports__